module.exports = __webpack_public_path__ + "img/limitedAccess.a5340b0.svg";